import { Card, Stack } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AddNewBtn from 'src/components/AddNewBtn'
import { BaseTable } from 'src/components/BaseTable/BaseTable'
import { useAccess } from 'src/hooks/useAccess.hook'
import { FEATURE } from 'src/util/enums'
import { chargingprofileListColumn } from '../ChargingProfile.constants'
import { CommonSearchbar } from 'src/layouts/dashboard/Searchbar'
import { yearFirstDateTimeFormat } from 'src/utils/formatTime'
import { yearFirstDateTimeFormatInTimezone } from 'src/utils/timezoneFormat'
import { useSelector } from 'react-redux'
import { useChargingProfile } from 'src/hooks/useChargingProfile.hook'
import { useSelectedTeam } from 'src/hooks/useSelectedTeam'
import ExportCSV from 'src/components/ExportCsv/ExportCSV'
import { Context } from 'src/context'

const ChargingProfileList = () => {
  const navigate = useNavigate()
  const hasCreateAccess = useAccess(FEATURE.CHARGERPROFILE,"C");
  const isReadOnly = useAccess(FEATURE.CHARGERPROFILE, "R");
  const { timezone } = useContext(Context);
  // const hasCreateAccess = true;
  const [tableData, setTableData] = useState();
  const rowOrCellClickRedirect = ({ id }) => {
    // if (isReadOnly) return;
    navigate(`${id}`)
  };

  const { teamId } = useSelectedTeam();
  const { isFetching } = useChargingProfile({ teamId });

  const {allData} = useSelector(state => state.chargingProfile)

  useEffect(() => {
    if (!isFetching){
      setTableData(allData);
    }
  }, [allData, isFetching]);

  const handleSearching = (event) => {
    const dataToSearchFrom = tableData;
    const searchValue = event.target.value.trim().toString().toLowerCase();
    if (searchValue) {
      const filteredDataArr = dataToSearchFrom.reduce(
        (filteredDataArr, currentObj) => {
          const relevantFields = [
            "charging_profile_pk",
            "stack_level",
            "description",
            "charging_profile_purpose",
            "charging_profile_kind",
            "recurrency_kind",
            "valid_from",
            "valid_to",
          ];
          const allValuesArr = Object.entries(currentObj)
            .filter(([key, value]) => relevantFields.includes(key))
            .map(([key, value]) =>
              key === "valid_from" || key === "valid_to"
                ? (timezone.timezone?.value
                    ? yearFirstDateTimeFormatInTimezone(value, timezone.timezone.value)
                    : yearFirstDateTimeFormat(value)
                  ).toString()
                : value ? value.toString().toLowerCase() : ""
            );
          const searchResult = allValuesArr.find((value) =>
            value.includes(searchValue)
          );
          if (searchResult) {
            filteredDataArr = [...filteredDataArr, currentObj];
          }
          return filteredDataArr;
        },
        []
      );
      setTableData(filteredDataArr);
    } else setTableData([...tableData]);
  };

  return (
    <>
      {hasCreateAccess &&
        <Stack
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          spacing={2}
          marginBottom={2}
        >
          <AddNewBtn to="/chargingprofile/new" label="Add new charging profile" />
        </Stack>
      }
      <Card sx={{ p: 2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
          <CommonSearchbar
            placeholder="Search"
            searchFunc={(e) => handleSearching(e)}
          />
          <ExportCSV
            rows={tableData || []}
            columns={chargingprofileListColumn(isReadOnly, timezone.timezone?.value)}
            csvMorphemes="charging-profile"
            csvColumns={chargingprofileListColumn(isReadOnly, timezone.timezone?.value)}
            timeZone={timezone.timezone?.value}
          />
        </Stack>
        <BaseTable
          rows={tableData ?? []}
          columns={chargingprofileListColumn(isReadOnly, timezone.timezone?.value)}
          pageSize={10}
          getRowId={(row) => row.charging_profile_pk}
          rowOrCellClickRedirect={rowOrCellClickRedirect}
          isReadOnly={isReadOnly}
          showExportCsvBtn={false}
          csvMorphemes="charging-profile"
          csvColumns={chargingprofileListColumn(isReadOnly, timezone.timezone?.value)}
        />
      </Card>
    </>
  )
}


export default ChargingProfileList